import { BEHAVIOR_TIMER_EVENT as E, type TimerPacket } from "./protocol.js";
import type { BehaviorTimerTransport } from "./client.js";

type TimerSocket = {
  connected: boolean;
  on(event: string, callback: (...args: any[]) => void): unknown;
  off(event: string, callback: (...args: any[]) => void): unknown;
  timeout(ms: number): { emit(event: string, ...args: any[]): unknown };
};
export function behaviorTimerSocketTransport(
  socket: TimerSocket,
  meetId?: string,
): BehaviorTimerTransport {
  const request = (event: string, payload?: unknown) =>
    new Promise<TimerPacket>((resolve, reject) => {
      if (!socket.connected) {
        reject(new Error("BEHAVIOR_TIMER_DISCONNECTED"));
        return;
      }
      const ack = (
        error: unknown,
        result: { ok?: boolean; packet?: TimerPacket; error?: string },
      ) => {
        if (error || !result?.ok || !result.packet)
          reject(new Error(result?.error ?? "BEHAVIOR_TIMER_UNAVAILABLE"));
        else resolve(result.packet);
      };
      if (payload === undefined) socket.timeout(5000).emit(event, ack);
      else socket.timeout(5000).emit(event, payload, ack);
    });
  return {
    request: () => request(E.request, meetId ? { meetId } : undefined),
    command: (command) =>
      request(E.command, meetId ? { meetId, command } : command),
    listen(receive, connection) {
      const connect = () => connection(true);
      const disconnect = () => connection(false);
      const status = (value: { connected?: boolean }) =>
        connection(value?.connected === true);
      socket.on(E.snapshot, receive);
      socket.on("connect", connect);
      socket.on("disconnect", disconnect);
      socket.on(E.status, status);
      connection(socket.connected);
      return () => {
        socket.off(E.snapshot, receive);
        socket.off("connect", connect);
        socket.off("disconnect", disconnect);
        socket.off(E.status, status);
      };
    },
  };
}
